export default __webpack_public_path__ + "static/media/icon-stars.1a4edaa9.svg";